module.exports = __webpack_public_path__ + "img/7.07c7d718.jpg";